<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'order-status-report.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'order-status-report.data' | transloco }}</small>
              <hx-date-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="m_datatable m-datatable m-datatable--default m-datatable--loaded m--margin-top-20 m--margin-bottom-20">
                <table class="m-datatable__table m-datatable__table--width" style="max-width: 450px;">
                  <thead class="m-datatable__head">
                    <tr class="m-datatable__row m-datatable__row--head">
                      <th class="m-datatable__cell">
                        <span>{{ 'order-status-report.table.head.status' | transloco }}</span>
                      </th>
                      <th class="m-datatable__cell text-right">
                        <span>{{ 'order-status-report.table.head.quantity' | transloco }}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="m-datatable__body">
                    <tr  *ngFor="let even = even;let i = index; let actionItem of statusReportList" class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                      <td class="m-datatable__cell">
                        <a [ngbTooltip]="'order-status-report.newTab' | transloco" target="_blank" [routerLink]="['/orders/list']" [queryParams]="{storeId: params.storeId, date: params.date, actions: actionItem.action, activeCart: false }">
                          {{ 'action.' + actionItem.action | transloco }}
                        </a>
                      </td>
                      <td class="m-datatable__cell text-right">
                        <a [ngbTooltip]="'order-status-report.newTab' | transloco" target="_blank" [routerLink]="['/orders/list']" [queryParams]="{storeId: params.storeId, date: params.date, actions: actionItem.action, activeCart: false }">
                          {{ actionItem.count }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
